











import Vue from 'vue';

export default Vue.extend({
	name: 'LoadingModal',
	props: {
		show: Boolean
	}
})
